/* eslint-disable max-len */
const React = require('react');


const Computer = ({ alt }) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={alt || ''}>
        <path fillRule="evenodd" clipRule="evenodd" d="M3.75 3.125H16.25C17.2855 3.125 18.125 3.96447 18.125 5V13.125H19.375V15C19.375 16.0355 18.5355 16.875 17.5 16.875H2.5C1.46447 16.875 0.625 16.0355 0.625 15V13.125H1.875V5C1.875 3.96447 2.71447 3.125 3.75 3.125ZM3.125 13.125H16.875V5C16.875 4.65482 16.5952 4.375 16.25 4.375H3.75C3.40482 4.375 3.125 4.65482 3.125 5V13.125ZM18.125 14.375H1.875V15C1.875 15.3452 2.15482 15.625 2.5 15.625H17.5C17.8452 15.625 18.125 15.3452 18.125 15V14.375Z" fill="#009EE3" />
    </svg>
);

module.exports = Computer;
